import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ExpedientNotesPage} from "./-page/expedient-notes.page";
import {ExpedientNotesPending} from "./-page/expedient-notes.pending";
import {expedientNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/expedients/$expedientId/notes/")({
  component: RouteComponent,
  pendingComponent: ExpedientNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: expedientNotesSearchSchema,
});

function RouteComponent() {
  const {expedientId} = Route.useParams();

  return <ExpedientNotesPage expedientId={expedientId} />;
}
